import InlineUploadComponent from '72cms-ui/components/helpers/InlineUploadComponent';
import InlineImageComponent from '72cms-ui/components/table-elements/InlineGlobalModalImageComponent';
import AssetInfoComponent from '72cms-ui/components/table-elements/AssetInfoComponent';
import InlineInputComponent from '72cms-ui/components/helpers/InlineInputComponent';
import FileFormComponent from '72cms-ui/components/table-elements/FileFormComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        image: {
            component: InlineImageComponent,
        },
        file_name: {
            label: 'File name',
            component: AssetInfoComponent,
            assetField: 'image',
        },
        comment: {
            component: InlineInputComponent,
        },
    },
    sortable: [],
    filterable: [],
    // modalFormComponent: FileFormComponent,
    inlineFormComponent: InlineUploadComponent,
    assetType: 'image',
    description: 'Please resize images to 800px x 600px prior to uploading. The filesize of your image should not exceed <strong>10MB</strong>.',
    defaultItem: {
        activate: true,
    },
    hideIfEmpty: true,
    pagination: false,
    searchable: false,
    treeView: false,
    toolbarDisabled: true,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.page-page_images.js